module.exports = __webpack_public_path__ + "media/images/footer-logo-dfa6dd98d970d296afe035822ee0ee02.png";